import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { Company } from '../interfaces/company'
import { UserPermission } from 'app/interfaces/permission';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {

  private tenantId: string
  private currentEnterprise;
  private companyId: string;
  private branchId: string;
  private searchRef = 'simulation/simul'
  private token: string;
  private isClosed = new Subject<boolean>();
  private urlRef = new Subject<string>();
  private permissions =  new Subject<UserPermission>();
  private regionId: string[]

  constructor() { }

  setRegionId(regionId) {
    console.log("regionId: ", regionId);
    const arr = regionId.split(',')
    console.log("arr: ", arr)
    this.regionId = arr.map(a => {
      return a.toString().replace("'", '').replace("'", '').trim()
    })

    console.log("regionId: ", this.regionId);
    localStorage.setItem('regionId', JSON.stringify(this.regionId));

  }

  getRegionId() {
    return JSON.parse(localStorage.getItem('regionId'))
  }

  setPermissions(permissions) {
    console.log('perm', permissions)
    this.permissions.next(permissions)
  }

  getPermissions(): Observable<UserPermission> {
    return this.permissions.asObservable()
  }

  isSidebarClosed(isClosed: boolean): void {
    this.isClosed.next(isClosed);
  }

  emmitSideBarClosed(): Observable<boolean> {
    return this.isClosed.asObservable();
  }

  setTenantId(tenant) {
    this.tenantId = tenant;
  }

  getTenantId() {
    return this.tenantId
  }

  setCompanyId(companyId) {
    this.companyId = companyId
  }

  getCompanyId() {
    return this.companyId;
  }

  setBranchId(branchId) {
    this.branchId = branchId
  }

  getBranchId() {
    return this.branchId;
  }

  getTokenId() {
    return JSON.parse(localStorage.getItem('currentUser')).tokenId
  }

  setTokenId(token) {
    this.token = token;
  }

  setCurrentEnterprise(enterprise) {
    this.currentEnterprise = enterprise;
  }

  getCurrentEnterprise() {
    return this.currentEnterprise;
  }

  setSearchRef(searchRef) {
    this.searchRef = searchRef;
  }

  getSearchRef() {
    return this.searchRef;
  }

  setUrlReference(companyId: string, branchId: string) {
    const urlRef = companyId + branchId;
    this.urlRef.next(urlRef);
  }

  getUrlReference(): Observable<any> {
    return this.urlRef.asObservable()
  }
}
